var _circle, _path, _path2, _polygon, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8WorkingAtHeight50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#1565c0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28,14c1.103,0,2-0.897,2-2s-0.897-2-2-2s-2,0.897-2,2S26.897,14,28,14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M38.85,15.736l-2.093,2.093C36.002,18.584,34.997,19,33.929,19H32c0-2.339-2.007-4.209-4.393-3.981 C25.527,15.217,24,17.083,24,19.172V21.5c0,0.646,0.411,1.19,0.983,1.401l-0.957,4.594c-0.141,0.676,0.293,1.338,0.969,1.479 c0.676,0.136,1.338-0.293,1.479-0.969L27.517,23h0.967l1.043,5.005C29.649,28.595,30.169,29,30.749,29 c0.084,0,0.17-0.009,0.256-0.026c0.676-0.141,1.11-0.803,0.969-1.479l-0.957-4.594C31.589,22.69,32,22.146,32,21.5V21h1.929 c1.603,0,3.109-0.624,4.243-1.757l1.591-1.591C39.496,16.992,39.194,16.352,38.85,15.736z M30,21h-4v-2h4V21z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "13,17 13,26 10,26 14.5,31 19,26 16,26 16,17"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24,31v10c6.891,0,12.81-4.107,15.479-10H24z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8WorkingAtHeight50);
export default __webpack_public_path__ + "static/media/icons8-working-at-height-50.6b26dea089b26c2f2d7e546b745fa225.svg";
export { ForwardRef as ReactComponent };